import React, { useState } from "react";
import calendarIcon from "../../assets/img/icons/calendar.svg";
import { INewsEventsData } from "../../exports/interfaces";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";
import { useTabs } from "../../hooks/lib/useTabs";
import { Link } from "react-router-dom";
import { PdfViwer } from "../PdfViwer";
import { stripHtml } from "../../exports/functions";

export const NewsEvents = (props: { newsEvents: INewsEventsData[] }) => {
  useTabs();
  const mobile = useMobile();
  const tab = useTab();
  const vacancyTiles = [
    {
      title: "Academic Post",
      sub_title: "Vacancies open for academic posts",
      date: "May 12, 2026",
      file: [],
      thumbnail: [],
      link: "/vacancy#academic",
      category: "",
    },
    {
      title: "Admin Post",
      sub_title: "Vacancies open for admin posts",
      date: "May 12, 2026",
      file: [],
      thumbnail: [],
      link: "/vacancy#admin",
      category: "",
    },
  ];

  const PostLayout = (props: { post: INewsEventsData }) => {
    const [openPdf, setOpenPdf] = useState(false);
    const [pdfPath, setPdfPath] = useState("");

    const openViewer = (path: string) => {
      setPdfPath(path);
      setOpenPdf(true);
    };

    const closeViewer = () => setOpenPdf(false);

    const pdfUrl = props.post.file?.[0]?.media?.url;

    const redirectUrl =
      props.post.title === "Call for Expression of Interest"
        ? "/announcement/eoi"
        : props.post.title === "Competition for Logo Design"
          ? "/announcement/logoCompetition"
          : props.post.title === "घर जग्गा भाडामा दिने प्रस्ताव आह्वान"
            ? "/announcement/landLease"
            : props.post.title === "विश्वविद्यालयको शैक्षिक कार्यक्रम सुरु"
              ? "/announcement/mpp"
              : props.post.title === "Admission Open Now for MPP"
                ? "/announcement/admissionOpen"
                : pdfUrl
                  ? "#"
                  : stripHtml(props.post.link);

    const isInternal =
      props.post.title === "Call for Expression of Interest" ||
      props.post.title === "Competition for Logo Design" ||
      props.post.title === "घर जग्गा भाडामा दिने प्रस्ताव आह्वान" ||
      props.post.title === "विश्वविद्यालयको शैक्षिक कार्यक्रम सुरु" ||
      props.post.title === "Admission Open Now for MPP";

    return (
      <>
        <div
          className="col-lg-4 wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.4s"
        >
          <div className="td_post td_style_1">
            {/* <a
                  href={post.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="td_post_thumb d-block"
                >
                  <img src={post.src} alt="blog post" />
                  <i className="fa-solid fa-link"></i>
                </a> */}

            <div className="td_post_info" style={{ height: "305px" }}>
              <div className="td_post_meta td_fs_14 td_medium td_mb_20">
                <span>
                  <img src={calendarIcon} alt="calendar icon" />
                  {props.post.date}
                </span>
              </div>

              <h2 className="td_post_title td_fs_24 td_medium td_mb_16">
                {pdfUrl ? (
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      openViewer(props.post?.file?.[0].media.url || "");
                    }}
                  >
                    {props.post.title}
                  </Link>
                ) : (
                  <Link
                    to={redirectUrl}
                    target={isInternal ? "_self" : "_blank"}
                    rel={isInternal ? "" : "noopener noreferrer"}
                  >
                    {props.post.title}
                  </Link>
                )}
              </h2>

              <p className="td_post_subtitle td_mb_24 td_heading_color td_opacity_7">
                {props.post.sub_title}
              </p>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {pdfUrl ? (
                  <Link
                    to="#"
                    className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                    onClick={(e) => {
                      e.preventDefault();
                      openViewer(props.post?.file?.[0].media.url || "");
                    }}
                  >
                    <span className="td_btn_in td_accent_color">
                      <span>Read More</span>
                    </span>
                  </Link>
                ) : (
                  <Link
                    to={redirectUrl}
                    target={isInternal ? "_self" : "_blank"}
                    rel={isInternal ? "" : "noopener noreferrer"}
                    className="td_btn td_style_1 td_type_3 td_radius_30 td_medium"
                  >
                    <span className="td_btn_in td_accent_color">
                      <span>Read More</span>
                    </span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <PdfViwer open={openPdf} onClose={closeViewer} path={pdfPath} />
      </>
    );
  };

  return (
    <section id="news-events">
      <div className="td_height_112 td_height_lg_40" />
      <div className="container">
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.2s"
        >
          {/* <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            HIGHLIGHTS
          </p> */}
          <h2 className="td_section_title td_fs_48 mb-0">Public Notice</h2>
        </div>

        <div className="td_height_30 td_height_lg_30" />

        <div className="td_notice_tabs">
          <ul
            className="td_tab_links td_style_1 td_mp_0 td_fs_20 td_medium td_heading_color wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <li
              className="active"
              style={{ width: mobile || tab ? "100%" : "unset" }}
            >
              <a
                href="#notice_tab_1"
                style={{
                  width: mobile || tab ? "100%" : "unset",
                  display: mobile || tab ? "flex" : "block",
                  justifyContent: "center",
                }}
              >
                All
              </a>
            </li>
            {props.newsEvents.filter((post) => post.category === "Admission")
              ?.length > 0 && (
              <li style={{ width: mobile || tab ? "100%" : "unset" }}>
                <a
                  href="#notice_tab_6"
                  style={{
                    width: "100%",
                    display: mobile || tab ? "flex" : "block",
                    justifyContent: "center",
                  }}
                >
                  Admission
                </a>
              </li>
            )}
            {/* {props.newsEvents.filter((post) => post.category === "Job Vacancy")
              ?.length > 0 && ( */}
            <li style={{ width: mobile || tab ? "100%" : "unset" }}>
              <a
                href="#notice_tab_2"
                style={{
                  width: "100%",
                  display: mobile || tab ? "flex" : "block",
                  justifyContent: "center",
                }}
              >
                Vacancy
              </a>
            </li>
            {/* )} */}
            {props.newsEvents.filter((post) => post.category === "Procurement")
              ?.length > 0 && (
              <li style={{ width: mobile || tab ? "100%" : "unset" }}>
                <a
                  href="#notice_tab_3"
                  style={{
                    width: "100%",
                    display: mobile || tab ? "flex" : "block",
                    justifyContent: "center",
                  }}
                >
                  Procurement
                </a>
              </li>
            )}
            {props.newsEvents.filter(
              (post) => post.category === "Expression of Interest",
            )?.length > 0 && (
              <li style={{ width: mobile || tab ? "100%" : "unset" }}>
                <a
                  href="#notice_tab_4"
                  style={{
                    width: "100%",
                    display: mobile || tab ? "flex" : "block",
                    justifyContent: "center",
                  }}
                >
                  Expression of Interest
                </a>
              </li>
            )}
            {props.newsEvents.filter((post) => !post.category)?.length > 0 && (
              <li style={{ width: mobile || tab ? "100%" : "unset" }}>
                <a
                  href="#notice_tab_5"
                  style={{
                    width: "100%",
                    display: mobile || tab ? "flex" : "block",
                    justifyContent: "center",
                  }}
                >
                  Others
                </a>
              </li>
            )}
          </ul>

          <div className="td_height_30 td_height_lg_30" />

          <div className="td_tab_body">
            <div className="td_tab active" id="notice_tab_1">
              <div className="row td_gap_y_30 justify-content-center">
                {props.newsEvents.map((post) => (
                  <PostLayout post={post} />
                ))}
              </div>
            </div>

            <div className="td_tab" id="notice_tab_6">
              <div className="row td_gap_y_30 justify-content-center">
                {props.newsEvents
                  .filter((post) => post.category === "Admission")
                  .map((post) => (
                    <PostLayout post={post} />
                  ))}
              </div>
            </div>
            <div className="td_tab" id="notice_tab_2">
              <div className="row td_gap_y_30 justify-content-center">
                {vacancyTiles.map((post) => (
                  <PostLayout post={post} />
                ))}
              </div>
            </div>
            <div className="td_tab" id="notice_tab_3">
              <div className="row td_gap_y_30 justify-content-center">
                {props.newsEvents
                  .filter((post) => post.category === "Procurement")
                  .map((post) => (
                    <PostLayout post={post} />
                  ))}
              </div>
            </div>
            <div className="td_tab" id="notice_tab_4">
              <div className="row td_gap_y_30 justify-content-center">
                {props.newsEvents
                  .filter((post) => post.category === "Expression of Interest")
                  .map((post) => (
                    <PostLayout post={post} />
                  ))}
              </div>
            </div>
            <div className="td_tab" id="notice_tab_5">
              <div className="row td_gap_y_30 justify-content-center">
                {props.newsEvents
                  .filter((post) => !post.category)
                  .map((post) => (
                    <PostLayout post={post} />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="td_height_120 td_height_lg_40" />
    </section>
  );
};
